import { render } from "./CreateItem.vue?vue&type=template&id=5365cf96&scoped=true"
import script from "./CreateItem.vue?vue&type=script&lang=js"
export * from "./CreateItem.vue?vue&type=script&lang=js"

import "./CreateItem.vue?vue&type=style&index=0&id=5365cf96&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5365cf96"]])

export default __exports__